import {
  isStringEmpty,
  checkTextLength,
  checkMinLength,
  isPrecise,
  integerPartLengthExceeds,
  isValidPhone
} from 'utils/utils';
import { emailValidation } from 'utils/email_strength';

// for store create and update field validation
export const ValidateStoreFields = (storeInfo, handleError) => {
  if (isStringEmpty(storeInfo.storeName)) {
    handleError('storeName', 'Please enter store name');
  }

  if (isStringEmpty(storeInfo.contactName)) {
    handleError('contactName', 'Please enter contact name');
  }

  if (isStringEmpty(storeInfo.email)) {
    handleError('email', 'Please enter email');
  }

  if (isStringEmpty(storeInfo.phone1)) {
    handleError('phone1', 'Please enter phone');
  }

  if (isStringEmpty(storeInfo.address)) {
    handleError('address', 'Please enter address');
  }

  const emailValid = emailValidation(storeInfo.email);
  handleError('email', emailValid);

  const storeNameMinLength = checkMinLength(storeInfo.storeName, 2);
  if (storeNameMinLength) {
    handleError('storeName', 'Please enter at least 2 characters');
  }

  const storeNameMaxLength = checkTextLength(storeInfo.storeName, 150);
  if (storeNameMaxLength) {
    handleError('storeName', 'Maximum 150 characters allowed ');
  }

  const contactNameMaxLength = checkTextLength(storeInfo.contactName, 150);
  if (contactNameMaxLength) {
    handleError('contactName', 'Maximum 150 characters allowed ');
  }

  const emailMaxLength = checkTextLength(storeInfo.email, 50);
  if (emailMaxLength) {
    handleError('email', 'Maximum 50 characters allowed ');
  }

  const phone1MaxLength = checkTextLength(storeInfo.phone1, 20);
  if (phone1MaxLength) {
    handleError('phone1', 'Maximum 20 characters allowed');
  }

  const phone2MaxLength = checkTextLength(storeInfo.phone2, 20);
  if (phone2MaxLength) {
    handleError('phone2', 'Maximum 20 characters allowed');
  }

  const addressMaxLength = checkTextLength(storeInfo.address, 255);
  if (addressMaxLength) {
    handleError('address', 'Maximum 255 characters allowed');
  }

  const markupPercentage = isPrecise(storeInfo.markupPercentage, 2);
  if (markupPercentage) {
    handleError('markupPercentage', 'Please enter 2 digits after decimal i.e xxx.xx');
  }

  const markupPercentageLength = integerPartLengthExceeds(storeInfo.markupPercentage, 3);
  if (markupPercentageLength) {
    handleError('markupPercentage', 'Maximum 3 digits allowed before decimal i.e xxx.xx');
  }

  const isNegativeValue = storeInfo?.markupPercentage < 0;

  if (isNegativeValue) {
    handleError('markupPercentage', 'Please enter valid markup percentage');
  }

  const phone1Validation = isValidPhone(storeInfo.phone1);
  if (phone1Validation) {
    handleError('phone1', 'Please enter phone containing only digits, hyphens & parentheses');
  }

  const phone2Validation = isValidPhone(storeInfo.phone2);
  if (phone2Validation) {
    handleError('phone2', 'Please enter phone containing only digits, hyphens & parentheses');
  }

  if (
    !phone1Validation &&
    !phone2Validation &&
    !markupPercentage &&
    emailValid == '' &&
    !isNegativeValue &&
    !isStringEmpty(storeInfo.storeName) &&
    !isStringEmpty(storeInfo.contactName) &&
    !isStringEmpty(storeInfo.email) &&
    !isStringEmpty(storeInfo.phone1) &&
    !isStringEmpty(storeInfo.address) &&
    !markupPercentageLength &&
    !storeNameMaxLength &&
    !storeNameMinLength &&
    !contactNameMaxLength &&
    !emailMaxLength &&
    !phone1MaxLength &&
    !phone2MaxLength &&
    !addressMaxLength
  ) {
    return true; // all fields are valid
  }
  return false;
};
